"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GhostButton = _interopRequireDefault(require("../../../Buttons/GhostButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardLink = (0, _styledComponents["default"])(_GhostButton["default"]).attrs(function (props) {
  return {
    color: "textSecondary",
    $hoverColor: "text",
    pV: "none"
  };
}).withConfig({
  displayName: "CardLink",
  componentId: "sc-1qyz9et-0"
})([""]);
var _default = CardLink;
exports["default"] = _default;